export default function PrivacyPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
      <div className="prose prose-invert prose-gray max-w-none space-y-6 text-gray-300 leading-relaxed">
        <p className="text-sm text-gray-500">Last updated: March 2026</p>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">1. Introduction</h2>
          <p>
            Nokset ("we", "our", "us") operates the website nokset.com (the "Service").
            This Privacy Policy explains how we collect, use, disclose, and safeguard your
            information when you visit our website or use our services. By using the Service,
            you agree to the collection and use of information in accordance with this policy.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">2. Information We Collect</h2>
          <h3 className="text-lg font-medium text-gray-50 mt-4 mb-2">Personal Information</h3>
          <p>When you create an account, we collect:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Email address</li>
            <li>Display name</li>
            <li>Password (stored securely using industry-standard hashing)</li>
          </ul>

          <h3 className="text-lg font-medium text-gray-50 mt-4 mb-2">Band Information</h3>
          <p>When you create or manage a band, we collect:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Band name, description, and location</li>
            <li>Band member email addresses (for invitations)</li>
            <li>Event details (dates, venues, descriptions)</li>
            <li>Setlist information</li>
            <li>Uploaded images (logos and assets)</li>
          </ul>

          <h3 className="text-lg font-medium text-gray-50 mt-4 mb-2">Automatically Collected Information</h3>
          <p>
            We may automatically collect certain information about your device and usage,
            including browser type, IP address, pages visited, and time spent on pages.
            This information is used to improve our Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Provide, maintain, and improve the Service</li>
            <li>Create and manage your account</li>
            <li>Enable band management features</li>
            <li>Display public band pages and event information</li>
            <li>Send invitation emails to band members</li>
            <li>Communicate with you about Service updates</li>
            <li>Ensure the security of our Service</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">4. Data Sharing and Disclosure</h2>
          <p>
            We do not sell your personal information. We may share information in the following cases:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Public Band Pages:</strong> Information you mark as public (band name, description, public events, public setlists) is visible to all visitors.</li>
            <li><strong>Band Members:</strong> Your email and display name are visible to other members of bands you belong to.</li>
            <li><strong>Service Providers:</strong> We use third-party services (Supabase for database, Cloudflare for hosting) that may process data on our behalf.</li>
            <li><strong>Legal Requirements:</strong> We may disclose information if required by law or to protect our rights.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">5. Data Storage and Security</h2>
          <p>
            Your data is stored securely using Supabase (powered by PostgreSQL) with
            row-level security policies. All data transmission is encrypted using TLS/SSL.
            While we implement industry-standard security measures, no method of transmission
            over the internet is 100% secure.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Export your data</li>
            <li>Withdraw consent for data processing</li>
          </ul>
          <p className="mt-2">
            To exercise these rights, please contact us at privacy@nokset.com.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">7. Cookies</h2>
          <p>
            We use essential cookies to maintain your authentication session. We do not use
            third-party tracking cookies or advertising cookies. By using our Service, you
            consent to the use of essential cookies.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">8. Children's Privacy</h2>
          <p>
            Our Service is not intended for children under the age of 13. We do not knowingly
            collect personal information from children under 13. If you are a parent or guardian
            and believe your child has provided us with personal information, please contact us.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any
            changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at
            privacy@nokset.com.
          </p>
        </section>
      </div>
    </div>
  );
}
